// src/belediye/services/personelApi.js
// FAZ-18 — Personel modülü uçları. Kapsam backend'de (get_user_scope_map); header YOK.

import api from "./belediyeApi";

const asList = (data) =>
  Array.isArray(data) ? data : Array.isArray(data?.results) ? data.results : [];

const clean = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );

export const fetchPersonelDizin = (params = {}) =>
  api.get("/personel/dizin/", { params: clean(params) }).then((r) => asList(r.data));

export const fetchPersonelProfil = (id) =>
  api.get(`/personel/dizin/${id}/`).then((r) => r.data);

// FAZ-23: şifre sıfırlama Personel'den KALDIRILDI (Kullanıcılar'a taşındı) —
// sistemApi.resetUserPassword (POST /common/users/{id}/reset-password/).
